import { IconButton } from "@mui/material";
import { CheckRegularIcon } from "@icons/CheckRegularIcon";

export function CorrectOptionCheckmark() {
    return (
        <IconButton
            sx={{
                padding: 0,
                width: "24px",
                height: "24px",
                border: "1px solid var(--community-color-early-dew)",
                "&:hover": {
                    backgroundColor: "var(--community-color-snow-white)",
                },
            }}
        >
            <CheckRegularIcon
                color="var(--community-color-early-dew)"
                width="12px"
                height="12px"
            />
        </IconButton>
    );
}
